import { render } from "./WhatsAppIcon.vue.ts?vue&type=template&id=033a3d33&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./WhatsAppIcon.vue?vue&type=template&id=033a3d33&ts=true"
import script from "./WhatsAppIcon.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./WhatsAppIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppIcon.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./WhatsAppIcon.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/credit-line/assets/icons/WhatsAppIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "033a3d33"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('033a3d33', __exports__)) {
    api.reload('033a3d33', __exports__)
  }
  
  module.hot.accept("./WhatsAppIcon.vue.ts?vue&type=template&id=033a3d33&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./WhatsAppIcon.vue?vue&type=template&id=033a3d33&ts=true", () => {
    api.rerender('033a3d33', render)
  })

}


export default __exports__